var map = {
	"./Bewakoof.png": 1271,
	"./CrytpoExplorer.jpg": 7676,
	"./MineWine.png": 9187,
	"./Travelious.png": 9408,
	"./bluefly.png": 5190,
	"./chatapplication.jpg": 2544,
	"./fullstackProject.jpg": 4403,
	"./portfolio.jpg": 1451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1393;